// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxInput_wrapper__rmVJp","circle":"CheckboxInput_circle__zkMy9"};